export const markers = [
    {
        id: 1,
        top: '73%',
        left: '21%',
        targetPage: 'Calheta',
    },
    {
        id: 2,
        top: '55%',
        left: '68%',
        targetPage: 'Camacha',
    },
    {
        id: 3,
        top: '73%',
        left: '53%',
        targetPage: 'Câmara de Lobos',
    },
    {
        id: 4,
        top: '64%',
        left: '64%',
        targetPage: 'Cancela',
    },
    {
        id: 5,
        top: '40%',
        left: '70%',
        targetPage: 'Machico',
    },
    {
        id: 6,
        top: '50%',
        left: '11%',
        targetPage: 'Porto Moniz',
    },
    {
        id: 7,
        top: '9%',
        left: '92%',
        targetPage: 'Porto Santo',
    },
    {
        id: 8,
        top: '73%',
        left: '45%',
        targetPage: 'Ribeira Brava',
    },
    {
        id: 9,
        top: '35%',
        left: '55%',
        targetPage: 'Santana',
    },
    {
        id: 10,
        top: '50%',
        left: '33%',
        targetPage: 'São Vicente',
    },
    {
        id: 11,
        top: '73%',
        left: '59%',
        targetPage: 'Zona Oeste',
    },

];